// AUTO-GENERATED by build-sfx-sprite.js — do not edit manually
// Run "npm run build:sfx" to regenerate
export const SFX_SPRITE_MAP = {
  "big_win": [
    0,
    3134.6938775510203
  ],
  "button_click": [
    5000,
    130.612244897959
  ],
  "epic_win": [
    7000,
    3056.3265306122444
  ],
  "expanding_wild": [
    12000,
    2169.229024943311
  ],
  "free_spin_cover": [
    16000,
    2455.5102040816337
  ],
  "free_spin_intro": [
    20000,
    4284.081632653063
  ],
  "free_spin_outro": [
    26000,
    7758.367346938776
  ],
  "free_spin_retrigger": [
    35000,
    3160.816326530615
  ],
  "free_spin_reveal": [
    40000,
    2533.87755102041
  ],
  "free_spin_transition": [
    44000,
    5590.204081632656
  ],
  "mega_win": [
    51000,
    3056.326530612246
  ],
  "reel_stop": [
    56000,
    261.2244897959215
  ],
  "scatter_1": [
    58000,
    1227.7551020408168
  ],
  "scatter_2": [
    61000,
    1234.5578231292507
  ],
  "scatter_win": [
    64000,
    1959.183673469383
  ],
  "spin": [
    67000,
    128.84353741496568
  ],
  "super_win": [
    69000,
    3056.326530612239
  ],
  "tension": [
    74000,
    3343.6734693877524
  ],
  "wild": [
    79000,
    1384.4897959183697
  ],
  "win": [
    82000,
    1044.897959183672
  ]
};
